import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import Legal from "../../assets/images/legal.svg";
import InputErrorMessage from "../InputErrorMessage/InputErrorMessage";
import "./StripeForm.css";
import call from "../../API/API";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

// const fonts = [
//   {
//     src: "url(../../assets/fonts/geometria/Geometria.otf)",
//     family: "Geometria",
//     style: "normal",
//   },
// ];
// const style = {
//   base: {
//     width: "55%",
//     background: "#EFF0F2",
//     mixBlendMode: "normal",
//     fontFamily: '"Arial"',
//     fontSize: "16px",
//     fontWeight: "normal",
//     lineHeight: "20px",
//     color: "#233142",
//     opacity: 0.4,
//     "::placeholder": {
//       color: "#a3a5ab",
//     },
//   },
//   invalid: {
//     color: "#EA6B3D",
//     iconColor: "#EA6B3D",
//   },
// };

const stripePromise = loadStripe(
  "pk_test_51Dm6OrCcwuKNdCDy7WURSUKijElFkLj0w6zO8nUQdJPXJA8QnFGw3vumIovA8neCQsT8BiaHzZjwJTqva50NPisr00xmLGKiPA"
);

const StripeForm = (props) => {
  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm handleStripeSubmit={props.handleStripeSubmit} />
    </Elements>
  );
};

export default StripeForm;

const CheckoutForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();

  const [clientName, setClientName] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [clientNameError, setClientNameError] = useState("");
  const [clientEmailError, setClientEmailError] = useState("");
  const [formError, setFormError] = useState("");
  const [isLoading, setStripeLoader] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStripeLoader(true);
    //Check if name is empty
    if (clientName === "") {
      setStripeLoader(false);
      setClientNameError("Please enter your name");
    } else {
      setClientNameError("");
    }

    //Check if email is empty
    if (clientEmail === "") {
      setStripeLoader(false);
      setClientEmailError("Please enter your email");
    } else {
      setClientEmailError("");
    }

    if (clientName !== "" && clientEmail !== "") {
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: elements.getElement(CardElement),
      });

      if (!error) {
        try {
          let result_api_call = await stripePaymentMethodHandler(paymentMethod);
          if (result_api_call.success === true) {
            localStorage.setItem("token", result_api_call.token);
            props.handleStripeSubmit();
          } else {
            setStripeLoader(false);
            console.log(result_api_call);
            setFormError("Error on your purchase");
          }
        } catch (err) {
          setStripeLoader(false);
          setFormError(err.message);
        }
      } else {
        setStripeLoader(false);
        setFormError("Card information is not correct.");
      }
    }
  };

  const stripePaymentMethodHandler = async (paymentMethod) => {
    let results = await call.payments.subscribe(paymentMethod);
    return results;
  };

  return (
    <form className="stripe-form" onSubmit={handleSubmit}>
      {isLoading === true ? (
        <div className="stripe-loader">
          <Loader
            type="Circles"
            color="#ea6b3d"
            height={100}
            width={100}
            timeout={1000000}
          />
        </div>
      ) : null}

      {formError !== "" || clientNameError !== "" || clientEmailError !== "" ? (
        <div className="error-handler">
          {formError ? <InputErrorMessage errorText={formError} /> : null}
          {clientNameError ? (
            <InputErrorMessage errorText={clientNameError} />
          ) : null}
          {clientEmailError ? (
            <InputErrorMessage errorText={clientEmailError} />
          ) : null}
        </div>
      ) : null}

      <div className="stripe-form-input">
        <div className="stripe-form-row">
          <label htmlFor="name">Name</label>
          <input
            type="text"
            placeholder="John Doe"
            id="name"
            name="full-name"
            value={clientName}
            onChange={(e) => {
              setClientName(e.target.value);
            }}
            className="stripe-input"
          />
        </div>

        <span className="stripe-form-separator"></span>
        <div className="stripe-form-row">
          <label htmlFor="email">Email</label>
          <input
            type="text"
            placeholder="email@domain.com"
            id="email"
            name="email"
            value={clientEmail}
            onChange={(e) => {
              setClientEmail(e.target.value);
            }}
            className="stripe-input"
          />
        </div>
      </div>
      <div className="stripe-form-input">
        <div className="stripe-form-row-predefined">
          <CardElement
            options={{
              style: {
                base: {
                  fontFamily: "Geometria",
                  fontWeight: "normal",
                  fontStyle: "normal",
                  fontSize: "16px",
                  lineHeight: "26px",
                  color: "#303244",
                },
              },
            }}
          />
        </div>{" "}
      </div>
      <PrimaryButton
        isDisabled={!stripe}
        primaryButtonText="Pay $49"
        // handlePrimaryBtnOnClick={this.props.handleStripeSubmit}
      />
      <img src={Legal} alt="Legal icons" className="legal-icons" />
    </form>
  );
};

// class StripeForm extends React.Component {
//     constructor(props) {
//         super(props);
//         this.state ={
//           clientName: '',
//           clientEmail: ''
//         }

//         this.handleStripeSubmit = this.handleStripeSubmit.bind(this);
//         this.handleNameOnChange = this.handleNameOnChange.bind(this);
//         this.handleEmailOnChange = this.handleEmailOnChange.bind(this);
//     }

//     async handleStripeSubmit(e) {
//       e.preventDefault();
//       console.log('test')
//       try{
//         let token = await this.props.stripe.createToken({name: this.props.nameValue, email: this.props.emailValue});
//         console.log(token);
//       }catch(err) {
//         console.log(err)
//       }
//   }

//   handleNameOnChange(e) {
//     this.setState({
//       clientName: e.target.value
//     })
//   }

//   handleEmailOnChange(e) {
//     this.setState({
//       clientEmail: e.target.value
//     })
//   }

//     render() {
//         return (
//           <Elements stripe={stripePromise}>
//             <form className="stripe-form" onSubmit={e => this.handleStripeSubmit(e)}>
//             <div className="stripe-form-input">
//             <div className="stripe-form-row">
//               <label htmlFor="name">
//                   Name
//               </label>
//               <input
//                 type="text"
//                 placeholder="John Doe"
//                 id="name"
//                 name="full-name"
//                 value={this.state.clientName}
//                 onChange={this.handleNameOnChange}
//               />
//             </div>
//             <span className="stripe-form-separator"></span>
//             <div className="stripe-form-row">
//               <label htmlFor="email">
//                   Email
//               </label>
//               <input
//                 type="text"
//                 placeholder="email@domain.com"
//                 id="email"
//                 name="email"
//                 value={this.state.clientEmail}
//                 onChange={this.handleEmailOnChange}
//               />
//             </div>
//             </div>
//             <div className="stripe-form-input">
//             <div className="stripe-form-row-predefined">
//             <CardElement style={{fonts}}/>
//             </div> </div>
//                 <PrimaryButton
//                   primaryButtonText={"Pay $" + this.props.productPrice}
//                   // handlePrimaryBtnOnClick={this.props.handleStripeSubmit}
//                 />
//               <img src={Legal} alt="Legal icons" className="legal-icons"/>
//             </form>
//             </Elements>
//          );
//     }
// }

// export default StripeForm;
